<template>
  <el-container type="flex" class="main_container">
    <base-header></base-header>
    <el-main>
      <el-table
        :data="botList"
        height="100%"
        v-loading="tableLoading">
        <el-table-column label="机器人头像和昵称" width="140">
          <template v-slot="scope">
            <div>
              <img :src=scope.row.avatar_url style="width: 30px; height: 30px" alt="">
              {{scope.row.bot_nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in table_column"
          :key="item.index"
          :prop="item.prop"
          :label="item.label"
          :align="item.align || 'center'"
          :width="item.width"
        ></el-table-column>
        <el-table-column label="查看群" align="center">
          <template v-slot="scope">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link" style="cursor: pointer;color: #409EFF;">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-zoom-in" :command="beforeHandleCommand(scope.row, 'chatroomList')">查看群关系</el-dropdown-item>
                <el-dropdown-item icon="el-icon-circle-plus" :command="beforeHandleCommand(scope.row, 'bindChatroomR')">绑定群关系</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
    <chatroom-list
      :dialog-visible="dialogVisible"
      :bot-username="choseBot.bot_username"
      :dialog-title="`${choseBot.bot_nickname}的群管理`"
      v-on:close="dialogVisible=false"
    ></chatroom-list>

    <el-dialog
      title="绑定群关系"
      :visible.sync="bindDialogVisible"
      width="30%"
       @close="closeBindQunDialog">

    <div style="margin-bottom: 20px;">⚠️注意：只能选择机器人未与团长绑定关系的群，否则请先解除群关系！</div>
      
      <el-form :model="bindQunForm" class="demo-form-inline">
        <el-form-item label="群">
          <el-select v-model="bindQunForm.chatroomname" filterable placeholder="请选择群">
            <el-option v-for="(chatroom, idx) in bindChatroomList" :key="idx" :label="chatroom.nickname" :value="chatroom.chatroomname">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团长id">
          <el-input v-model="bindQunForm.clientId" placeholder="请输入团长id" style="width:50%" @input="bindQunForm.clientId=bindQunForm.clientId.replace(/^\.+|[^\d.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindQun">绑定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import pageMixin from '../../../mixins/page'
import ChatroomList from './ChatroomList'

export default {
  name: 'BotList',
  components: {ChatroomList},
  mixins: [pageMixin],
  data () {
    return {
      botListURL: this.getDomain() + 'bmbot/get_bot_list',
      botChatroomURL: this.getDomain() + 'bmbot/get_chatroom_list',
      bindQunURL: this.getDomain() + 'bmbot/bind_qun',
      tableLoading: true,
      botList: [],
      choseBot: {
        bot_username: undefined,
        bot_nickname: undefined
      },
      dialogVisible: false,
      bindDialogVisible: false,
      table_column: [
        {
          prop: 'add_time',
          label: '添加时间'
        },
        {
          prop: 'bot_username',
          label: '机器人微信号'
        },
        {
          prop: 'bind_client_count',
          label: '绑定团长数量'
        },
        {
          prop: 'add_chatroom_count',
          label: '进群数'
        }
      ],
      bindQunForm: {
        'chatroomname': '',
        'clientId': ''
      },
      bindChatroomList: []
    }
  },
  computed: {
    dialogTitle: `的群管理`
  },
  methods: {
    getList () {
      let params = {
        page: this.page,
        pagesize: this.pagesize
      }
      let handle = res => {
        this.botList = res.data.content.data
        this.totalCount = res.data.content.total_count
        this.botList.forEach(item => {
          item.add_time = this.timeTransform(item.add_time)
        })
      }
      let loadings = () => {
        this.tableLoading = false
      }
      this.tableLoading = true
      this.__axios(this.botListURL, params, handle, loadings)
    },
    beforeHandleCommand(row, command){
      return {
          'row': row,
          'command':command
      }
    },
    handleCommand(command) {
      this.choseBot = command.row
      switch (command.command) {
        case 'chatroomList':
          this.dialogVisible = true
          break
        case 'bindChatroomR':
          this.getChatroomList()
          this.bindDialogVisible = true
          break
      }
    },
    getChatroomList() {
      let params = {
        bot_username: this.choseBot.bot_username
      }
      let handle = res => {
        this.bindChatroomList = res.data.content.chatroom_list
      }
      this.__axios(this.botChatroomURL, params, handle)
    },
    bindQun() {
      let params = {
        bot_username: this.choseBot.bot_username,
        client_id: Number(this.bindQunForm.clientId),
        chatroomname: this.bindQunForm.chatroomname,
      }
      let handle = res => {
        console.log(res)
        this.$message('绑定成功');
        this.bindDialogVisible = false
      }
      this.__axios(this.bindQunURL, params, handle)
    },
    closeBindQunDialog() {
      console.log("close")
      this.bindQunForm.chatroomname = ''
      this.bindQunForm.clientId = ''
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
  p {
    cursor: pointer;
    color: #3a8ee6;
  }
</style>
